import serviceBase from 'app/Services/serviceBase'

class MarketingSectionActions {
  getMarketingCustomSectionByAll = async () => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/all`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionListByIdentifier = (identifier) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/marketing-custom-sections-by-name/${identifier}`
    return serviceBase.get(url).then(
      (response) => {
        return response.status === 200 ? [response.data] : []
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionListByCountry = (countryId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/by-country-id/${countryId}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data.data || []
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionListByCountryAndState = (countryId, state) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/by-state/${countryId}/${state}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data.data || []
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionListByCountryStateAndCounty = (countryId, state, county) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/by-county/${countryId}/${state}/${county}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data.data || []
      },
      (err) => {}
    )
  }

  deleteMarketingSections = async (ids) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section/delete-sections`

    return serviceBase.post(url, { ids }).then(
      (response) => {
        return response
      },
      (err) => {}
    )
  }

  //PREVIEW
  getMarketingCustomSectionPreviewByAll = async () => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/all`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionPreviewByCountry = (countryId) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/by-country-id/${countryId}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data.data || []
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionPreviewByCountryAndState = (countryId, state) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/by-state/${countryId}/${state}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data.data || []
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionPreviewByCountryStateAndCounty = (countryId, state, county) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/by-county/${countryId}/${state}/${county}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data.data || []
      },
      (err) => {}
    )
  }

  searchMarketingCustomSectionPreviewByIdentifier = (identifier) => {
    let url = `${window._env_.COMMUNITY_API_URL}/marketing-custom-section-preview/marketing-custom-sections-by-name/${identifier}`
    return serviceBase.get(url).then(
      (response) => {
        return response.status === 200 ? [response.data] : []
      },
      (err) => {}
    )
  }
}

export default new MarketingSectionActions()
